module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'm4pg955a',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
